export default __webpack_public_path__ + "static/media/Frontend-Eng.40969a1a.pdf";